import { render } from "./beautyVideos.vue?vue&type=template&id=d10cb746&scoped=true"
import script from "./beautyVideos.vue?vue&type=script&lang=js"
export * from "./beautyVideos.vue?vue&type=script&lang=js"

import "./beautyVideos.vue?vue&type=style&index=0&id=d10cb746&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d10cb746"]])

export default __exports__